import Dashboard from './DashboardPage';

export default Dashboard;
